
import { observable, action, runInAction } from 'mobx';
import { message } from 'antd';

class store {
    @observable data = [];
}

const kpi = new store();

export default kpi;


// WEBPACK FOOTER //
// ./src/store/1/kpi.js